import { createFileRoute } from "@tanstack/react-router";
import { RfqPrint } from "@/features/rfqs/RfqPrint";

export const Route = createFileRoute("/_authenticated/rfqs/$rfqId/print")({
  component: () => {
    const { rfqId } = Route.useParams();
    return <RfqPrint id={rfqId} />;
  },
});
